import { BasePath } from '@constants/Auth';
import { SafeAny } from '@models/common';
import { getConfig } from '@utils/config';
import { history } from '@utils/history';
import axios from 'axios';

const config = getConfig();

axios.defaults.baseURL = config.ServerUrl || '/';
axios.defaults.headers.common['TenantId'] = config.TenantId || '';

export const handleApiError = (error: SafeAny) => {
  if (error.response?.status === 403) {
    history.push(BasePath + '/access_denied');
  }
};

export default axios;
